import {Model, Signal} from "@lernetz/ts-lib";

export class DropDownController extends Model {
    filterChange: Signal<unknown>;
    filterOpen: Signal<unknown>;
    constructor() {
        super();
        this.filterChange = new Signal();
        this.filterOpen = new Signal();
    }
    clickTag(tag) {
        tag.active = !tag.active;
        this.filterChange.dispatch(tag);
    }
}
